module.exports = __webpack_public_path__ + "img/Prime2_logo_channel_b_m.d6d35d77.svg";